import getENV from "../util/getENV";
import useSmartContract from "./useSmartContract";

export default function useSkeleKeys() {
    const { modules: { keys: { contract } } } = getENV();
    const smartContract = useSmartContract(contract);
    const { contract: keys } = smartContract;
    return { ...smartContract, keys }

}